<template lang="pug">
v-dialog(:z-index="100", width="1500", v-model="docsShown")
  v-card(style="flex: 1")
    v-carousel(
      v-if="docsShown",
      width="100%",
      height="80vh",
      show-arrows-on-hover,
      v-model="currentDocIndex"
    )
      v-carousel-item(v-for="(doc, i) in docs", :key="i")
        v-sheet(height="100%")
          v-card.slide-inner(flat)
            v-card-title
              .headline(v-text="doc.name")
              v-btn.ml-2(icon, @click="download(doc)")
                v-icon mdi-download
              v-spacer
              v-btn(icon, @click="docsShown = false")
                v-icon mdi-close
            v-card-text.slide-inner-doc
              pdf.pdf-doc(
                v-if="getType(doc.name) === 'doc' && pdfRaw",
                v-for="i in numPages"
                :key="i"
                :src="pdfRaw"
                :page="i"
              )
              .slide-inner.d-flex.align-center.justify-center(
                v-else-if="getType(doc.name) === 'img'"
              )
                img.img(:src="getURL(doc.ID)")

  v-card.ml-4(v-if="hasSign", style="width: 400px; align-self: flex-end")
    v-card.abs
      .abs-inner
        .d-flex.justify-end
          v-btn.ma-1(icon, @click="close")
            v-icon mdi-close
        VueSignaturePad(
          ref="signaturePad",
          width="400px",
          height="300px",
          :options="{ onBegin, penColor: '#c0f' }"
        )
        .d-flex
          v-btn.ma-1(style="flex: 1", @click="clear") clear
          v-btn.ma-1(style="flex: 1", color="primary", @click="close") sign
</template>

<script>
import vuePdf from "vue-pdf";

export default {
  name: "doc_viewer",

  components: {
    pdf: vuePdf,
  },

  props: {
    docID: {
      type: Number,
    },

    hasSign: {
      type: Boolean,
      default: false,
    },

    docs: {
      type: Array,
      default: () => [],
    },

    value: {
      type: Boolean,
      required: true,
    },
  },

  data: () => ({
    currentDocIndex: 0,
    pdfRaw: "",
    numPages: undefined,
  }),

  computed: {
    docsShown: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },

  methods: {
    getType(name) {
      const parts = name.split(".");
      const ext = parts[parts.length - 1];
      switch (ext) {
        case "pdf":
        case "doc":
        case "docx":
          return "doc";
        default:
          return "img";
      }
    },

    getURL(id) {
      if (this.$auth.user().role === "expert")
        return [
          process.env.VUE_APP_API_URL,
          "expert",
          "case",
          this.$store.state.expert.usercase.usercase.ID,
          "sponsorship",
          "documents",
          this.docID,
          "file",
          id,
        ].join("/");
      return [
        process.env.VUE_APP_API_URL,
        "employer",
        "case",
        this.$store.getters["usercase/currentUsercase"].ID,
        "sponsorship",
        "documents",
        this.docID,
        "file",
        id,
      ].join("/");
    },

    clear() {
      this.$refs.signaturePad.clearSignature();
    },

    close() {
      this.$store.commit("cancelViewDoc");
    },

    onBegin() {
      this.$refs.signaturePad.resizeCanvas();
    },

    async getPreview(doc) {
      await this.axios
        .get(this.getURL(doc.ID), { responseType: "blob" })
        .then(async (resp) => {
          let blob = new Blob([resp.data], { type: "application/pdf" });
          const arrBuf = await new Response(blob).arrayBuffer();
          var datares = "data:application/pdf;base64," +
              btoa(
                  new Uint8Array(arrBuf).reduce(
                      (data, byte) => data + String.fromCharCode(byte),
                      ""
                  )
              )

          var loadingTask = vuePdf.createLoadingTask(datares)
          this.pdfRaw = loadingTask
          this.pdfRaw.promise.then(pdf => {
            this.numPages = pdf.numPages;
          });
        })
        .catch((err) => console.error(err));
    },

    download(doc) {
      this.axios
        .get(this.getURL(doc.ID), { responseType: "blob" })
        .then((resp) => {
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(new Blob([resp.data]));
          link.setAttribute("download", doc.name);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((err) => console.error(err));
    },
  },

  watch: {
    docsShown() {
      this.currentDocIndex = 0;
      this.getPreview(this.docs[this.currentDocIndex]);
    },

    currentDocIndex() {
      this.getPreview(this.docs[this.currentDocIndex]);
    },
  },
};
</script>

<style lang="sass" scoped>
.slide-inner
  width: 100%
  height: 100%
  display: flex
  flex-direction: column

  &-doc
    flex: 1
    overflow-y: scroll
    .pdf-doc
      margin-bottom: 16px

.frame
  width: 100%
  height: 100%

.cards
  width: 100vw

.card
  flex: 1
  height: 100%

  .inner
    width: 100%
    height: 100%
    display: flex
    justify-content: center
    align-items: center

.img
  max-width: 90%
  max-height: 90%

.abs
  z-index: 1
  width: 400px
  transition: bottom .3s

  &-inner
    position: relative
</style>